<button
  mat-stroked-button
  color="accent"
  footer
  (click)="setAppointmentAsArranged()"
>
  {{ "Privilegovan" | translate }}
</button>
